import moment from "moment";

/**
 * Parsea las líneas de texto extraídas de un PDF de Nadro.
 * Retorna un Map<descripcionLower, { lotes, cantidadLinea }>
 */
export function parsearLineasNadro(allLines) {
  const productos = [];
  let lastProduct = null;

  for (const line of allLines) {
    const eanMatch = line.match(/^(\d{8,13})\s+/);

    if (eanMatch) {
      const cantMatch = line.match(/\s(\d+)\s+H87\b/);
      const cant = cantMatch ? parseInt(cantMatch[1], 10) : null;

      const descMatch = line.match(
        /(?<!\d)\d{8}(?!\d)\s+(.*?)\s+[\d,]+\.\d{2}\s+[\d,]+\.\d{2}/
      );
      const descripcion = descMatch ? descMatch[1].trim() : null;

      lastProduct = {
        ean: eanMatch[1],
        descripcion,
        cantidadLinea: cant,
        lotes: [],
      };

      productos.push(lastProduct);
      continue;
    }

    if (lastProduct) {
      const lotMatch = line.match(
        /Lot\.([A-Z0-9]+).*?Cad\.(?:(\d{2})\.)?(\d{2})\.(\d{4}|\d{2})/
      );

      if (lotMatch) {
        const numeroLote = lotMatch[1];
        const dia = lotMatch[2];
        const mes = lotMatch[3];
        const anio = lotMatch[4];

        let caducidad = null;

        if (dia) {
          caducidad = moment(
            `${dia}/${mes}/${anio}`,
            anio.length === 2 ? "DD/MM/YY" : "DD/MM/YYYY",
            true
          );
        } else {
          caducidad = moment(
            `01/${mes}/${anio}`,
            anio.length === 2 ? "DD/MM/YY" : "DD/MM/YYYY",
            true
          );
        }

        lastProduct.lotes.push({
          numero: numeroLote,
          caducidad,
          cantidad: lastProduct.cantidadLinea,
        });
      }
    }
  }

  const productsByDesc = new Map();

  for (const prod of productos) {
    if (!prod.descripcion) continue;

    const key = prod.descripcion.toLowerCase().trim();

    if (!productsByDesc.has(key)) {
      productsByDesc.set(key, { lotes: [], cantidadLinea: null });
    }

    const existing = productsByDesc.get(key);

    if (prod.lotes.length > 0) {
      for (const lote of prod.lotes) {
        const dup = existing.lotes.find((l) => l.numero === lote.numero);

        if (dup) {
          dup.cantidad = (Number(dup.cantidad) || 0) + (Number(lote.cantidad) || 0);
        } else {
          existing.lotes.push({ ...lote });
        }
      }
    } else if (prod.cantidadLinea != null) {
      existing.cantidadLinea = (existing.cantidadLinea || 0) + prod.cantidadLinea;
    }
  }

  return productsByDesc;
}